import React from 'react';
import {PropTypes} from 'prop-types';
import {ProductBox} from 'components/fair/fair-product';
import {connect} from 'react-redux';
import {Fairs, Products} from 'base/api';
import {SingleImageUploader} from 'components/uploader';
import ReactPaginate from 'react-paginate';
import {toastr} from 'react-redux-toastr';
import axios from 'axios';
import cookie from 'react-cookie';
import CONFIG from 'base/constants/config';
import Modal from 'react-modal'
import _ from 'lodash';

class AddProductOfBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      business: {},
      products: [],
      allProduct: [],
      fairCategories: [],
      allProductInFair: [],
      selectedProducts: [],
      modalIsOpen: false,
      API_URL: '',
      access_token: cookie.load('accessToken') || ''
    }
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  componentDidMount() {
    Fairs.actions.get.request({id: this.props.params.id}).then(response => {;
      if (response.data) {
        this.setState({
          API_URL: response.data.fair.apiUrl,
          fairCategories: response.data.fair.categoryIds
        }, () => {
          this.getBusinessInfo();
        })
      }
    });
  }

  getBusinessInfo(id) {
    axios({
      method: 'GET',
      url:`${this.state.API_URL}/businesses/${this.props.params.idBusiness}`,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      if (response.data) {
        this.setState({
          business: response.data
        }, () => {
          Promise.all([
            this.getAllProductOfBusiness(),
            this.getProductOfBusiessInFair()
          ]).then((res) => {
            this.getData()
          });
        })
      }
    }).catch(error => {
      console.log(error)
    })
  }

  getAllProductOfBusiness() {
    return Products.actions.listByBusiness.request({id: this.state.business.dntId.substring(4), filter: { limit: 1000, order: 'createdAt DESC'}}).then(response => {
      if (response.data) {}
        this.setState({allProduct: response.data})
    })
  }

  getProductOfBusiessInFair() {
    return axios({
      method: 'GET',
      url:`${this.state.API_URL}/businesses/${this.props.params.idBusiness}/products?filter[limit]=1000&filter[order]=createdAt DESC`,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      if (response.data) {
        this.setState({allProductInFair: response.data})
      }
    })
  }

  getData() {
    let listProduct = []
    this.state.allProduct.map(item => {
      if (_.findIndex(this.state.allProductInFair, (fairProduct) => fairProduct.dntId.substring(4) === item.id) === -1 &&
        _.findIndex(this.state.fairCategories, (fairCategory) => { return _.findIndex(item.categoryIds, (category) => category === fairCategory) !== -1}) !== -1) {
          listProduct.push(item)
        }
    })

    this.setState({
      products: listProduct
    })
  }

  onChange(e) {
    this.setState({
      searchTerm: e.target.value,
      offset: 0
    });
  }

  openModal() {
    this.setState({modalIsOpen: true})
  }

  closeModal() {
    this.setState({modalIsOpen: false})
  }

  onAddNew(product) {
    if (this.state.selectedProducts.length === 15) {
      toastr.warning('Giới hạn!', 'Chỉ được thêm tối đa 15 sản phẩm một lần.');
      return
    }
    let exist = _.findIndex(this.state.selectedProducts, (item) => item.id === product.id) !== -1;
    if (!exist) {
      this.setState({
        selectedProducts: [
          ...this.state.selectedProducts,
          product
        ]
      })
    }
  }

  onRemove(product) {
    if (product.id) {
      this.setState({
        selectedProducts: [...this.state.selectedProducts].filter(item => item.id !== product.id)
      })
    }
  }

  onSubmit() {
    if (this.state.selectedProducts.length) {
      let params = {
        businessId: this.state.business.dntId.substring(4),
        products: this.state.selectedProducts
      }
      Fairs.actions.addProducts.request({id: this.props.params.id}, params).then(response => {
        toastr.success('Thành công!', 'Thêm sản phẩm thành công.');
        this.setState({ selectedProducts: [], modalIsOpen: false}, () => {
          Promise.all([
            this.getAllProductOfBusiness(),
            this.getProductOfBusiessInFair()
          ]).then((res) => {
            this.getData()
          });
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }

  render() {
    return (
      <div>
        <div className='row'>
          <div className="container-fluid list-add-product">
            <div className='row'>
              {
                this.state.products.map(products => {
                  return (
                    <div className='col-lg-3 col-md-6 fair-products'>
                      <ProductBox key={products.id} {...products} addNewProduct onRemove={this.onRemove.bind(this)} onAddNew={this.onAddNew.bind(this)} selectedProducts={this.state.selectedProducts}/>
                    </div>
                  );
                })
              }
            </div>
          </div>
          { this.state.products.length ?
            <div className='products' style={{ backgroundColor: 'transparent', width: 300, float: 'none', margin: '0 auto', border: 'none'}}>
              <div className='wrap-actions wrap-btn'>
                { this.state.selectedProducts.length ? <button className='btn-highlight' onClick={this.openModal.bind(this)}>Thêm các sản phẩm đã chọn vào hội chợ</button> : null }
              </div>
            </div> : <p className='text-center'>Không có sản phẩm phù hợp để thêm vào hội chợ</p>
          }
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal.bind(this)}
          className='modal-custom modal-confirm'
        >
          <div className='title-block'>
            <button className='btn-close' onClick={this.closeModal.bind(this)}>×</button>
          </div>
          <div className='wrap-content-modal'>
            <p>Xác nhận thêm các sản phẩm đã chọn vào hội chợ</p>
            <div className='products' style={{ backgroundColor: 'transparent', width: 120, float: 'none', margin: '0 auto', border: 'none'}}>
              <div className='wrap-actions wrap-btn'>
                <button className='btn-highlight' onClick={this.onSubmit.bind(this)}>Xác nhận</button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default AddProductOfBusiness;


// WEBPACK FOOTER //
// ./components/fair/fair-product/AddProductOfBusiness.jsx